import { supabase } from './lib/Supabase'

/**
 * Métodos de autenticación reutilizables
 * Sin estado de React - solo operaciones puras de Supabase
 */

// ========== AUTH BÁSICO ==========
export const signInWithPassword = async (email: string, password: string) => {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password })
  if (error) throw error
  return data
}

export const signOut = async () => {
  const { error } = await supabase.auth.signOut()
  if (error) throw error
}

export const getSession = async () => {
  const { data: { session }, error } = await supabase.auth.getSession()
  if (error) throw error
  return session
}

export const getUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) throw error
  return user
}

export const refreshSession = async () => {
  const { data, error } = await supabase.auth.refreshSession()
  if (error) throw error
  return data
}

// ========== MFA ENROLLMENT ==========
export const enrollMFA = async (friendlyName: string) => {
  const { data, error } = await supabase.auth.mfa.enroll({
    factorType: 'totp',
    friendlyName
  })
  if (error) throw error
  return data
}

export const unenrollMFA = async (factorId: string) => {
  const { data, error } = await supabase.auth.mfa.unenroll({ factorId })
  if (error) throw error
  return data
}

// ========== MFA CHALLENGES ==========
export const createMFAChallenge = async (factorId: string) => {
  const { data, error } = await supabase.auth.mfa.challenge({ factorId })
  if (error) throw error
  return data
}

export const verifyMFAChallenge = async (factorId: string, challengeId: string, code: string) => {
  const { data, error } = await supabase.auth.mfa.verify({
    factorId,
    challengeId,
    code
  })
  if (error) throw error
  return data
}

// ========== MFA INFO ==========
export const getMFAFactors = async () => {
  const { data, error } = await supabase.auth.mfa.listFactors()
  if (error) throw error
  return data
}

export const getAuthenticatorAssuranceLevel = async () => {
  const { data, error } = await supabase.auth.mfa.getAuthenticatorAssuranceLevel()
  if (error) throw error
  return data
}

// ========== MFA HELPERS ==========
export const verifyMFA = async (factorId: string, code: string, challengeId?: string) => {
  let finalChallengeId = challengeId

  // Si no se proporciona challenge, crear uno nuevo
  if (!finalChallengeId) {
    const challenge = await createMFAChallenge(factorId)
    finalChallengeId = challenge.id
  }

  return await verifyMFAChallenge(factorId, finalChallengeId, code)
}

export const checkMFAStatus = async () => {
  try {
    const aalData = await getAuthenticatorAssuranceLevel()
    const factors = await getMFAFactors()

    return {
      currentLevel: aalData.currentLevel,
      nextLevel: aalData.nextLevel,
      hasMFAFactors: factors.totp && factors.totp.length > 0,
      factors: factors.totp || []
    }
  } catch (error) {
    console.error('Error checking MFA status:', error)
    return {
      currentLevel: 'aal1',
      nextLevel: null,
      hasMFAFactors: false,
      factors: []
    }
  }
}

// ========== AUTH STATE LISTENER ==========
export const onAuthStateChange = (callback: (event: string, session: any) => void) => {
  return supabase.auth.onAuthStateChange(callback)
}

// ========== UTILIDADES ==========
export const generateRandomDeviceName = () => {
  const devices = ['iPhone', 'Android', 'Tablet', 'MacBook', 'PC', 'Laptop']
  const adjectives = ['Personal', 'Trabajo', 'Principal', 'Secundario', 'Casa', 'Oficina']
  const randomDevice = devices[Math.floor(Math.random() * devices.length)]
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)]
  const randomNumber = Math.floor(Math.random() * 999) + 1

  return `${randomDevice} ${randomAdjective} ${randomNumber}`
}

export const query = supabase